// extracted by mini-css-extract-plugin
export default {"container":"PromoCode_container__nGeKE"};